export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/trumpet.bcd4715.svg";